import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import SEO from "../../common-components/SEO";
// external styling (optional)

const MediaHub = () => {
  const [videos, setVideos] = useState([
    { id: "qzjW3ENI8bg", title: "McGAN'S OOTY SCHOOL OF ARCHITECTURE / 13th GRADUATION DAY" },
    { id: "kG4lKPCY9gY", title: "McGAN'S OOTY SCHOOL OF ARCHITECTURE / 19th INDUCTION DAY" },
    { id: "iT6rWz88pfc", title: "McGAN'S OOTY SCHOOL OF ARCHITECTURE / 12th GRADUATION DAY" },
    { id: "iPvjeMZDSuk", title: "McGAN'S OOTY SCHOOL OF ARCHITECTURE / 11th GRADUATION DAY" },
    { id: "WuWpPrWyf7Y", title: "McGAN'S OOTY SCHOOL OF ARCHITECTURE / 10th GRADUATION DAY" },
    { id: "CpbPXEdGL1k", title: "McGAN'S OOTY SCHOOL OF ARCHITECTURE / 08th GRADUATION DAY" },
    { id: "Aca7RybQVzg", title: "McGAN'S OOTY SCHOOL OF ARCHITECTURE / 07th GRADUATION DAY " },
    { id: "wrqvL-63BuI", title: "McGans World Record Event 2023" },
    { id: "BrIMASekPUk", title: "Veetuku oru vinyani event Mcgans ooty school of architecture" },
    { id: "emJdDIYEdfo", title: "McGAN'S Ooty School of Architecture / 18th INDUCTION DAY BATCH 2025" },
    { id: "ZgPXlA7vOqA", title: "NEPCON - 2021 " },
    { id: "OUJjH3IVNTo", title: "NEPCON - 2021 DAY 2" }, { id: "FfGxN9_VD_8", title: "NATA Exam cleared? Score 70 or above? Get a Scholarship" },
    { id: "1X6aH2IUKJw", title: "Architecture college Admissions open 2025-2026" },
    { id: "-DzH5NOduXU", title: "Visit McGAN'S Ooty School of Architecture | Creative Learning Experience | 2025" },
    { id: "kdINihTGQNo", title: "Kurumba Painting Art" },
    { id: "vHDRY7kHtYw", title: "Architectural Design 06 I Campus Design Walkthrough I Students Work" },
    { id: "uVQ7xovmOV8", title: "A JOURNEY OF McGAN'S OOTY SCHOOL OF ARCHITECTURE 2021" },
    { id: "FNTp8U9AAEE", title: "✨ Critical Design Studio - Physical Model Making ✨At McGan's Ooty School of Architecture" },
    { id: "eem52WbBqXA", title: "DESIGN EG OF AMBIENCE OF KFC AND THALAPPAKATTI" },
    { id: "lqqCZCOdLZU", title: "TOTAL RECALL" },
    { id: "nbXEybgs3Vg", title: "Zonasa 2016 Award winner Mcgans Ooty School of Architecture" },
    { id: "ft23snZz1Z8", title: "Jaya TV Interview - 1" },
    { id: "rrlKHkR6TXU", title: "Global learning experience : MCGAN'S Ooty students in Dubai" },
  ]);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      {/*  Page Banner */}
      <SEO
        fullTitle={"Media Hub — McGAN'S Ooty School of Architecture | Videos & Events"}
        description={"Watch graduation days, events, student work and official videos from McGAN'S Ooty School of Architecture."}
        keywords={`mcgans videos, media hub, graduation day videos, architecture events, mcgans media`}
        image={"https://i.ytimg.com/vi/iT6rWz88pfc/maxresdefault.jpg"}
        url={"https://mcgansarch.com/mediahub"}
      />
      <h1 style={{ display: "none" }}>McGAN'S Media Hub — videos, graduation days & events</h1>

      <div className="page-banner-area bg-2">
        <div className="container">
          <div className="page-banner-content">
            <h3 className="BannerHeader">McGAN’S Media Hub</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="navspace">Media Hub</li>
            </ul>
          </div>
        </div>
      </div>

      {/*  Media Section */}
      <section className="media-hub">
        <div className="container">
          <h2 data-aos="fade-up"> McGAN’S Media Hub</h2>
          <p data-aos="fade-up" className="intro-text">
            Watch the latest videos, performances, and events from McGAN’S Ooty College of Fine Arts.
          </p>

          <div className="video-grid">
            {videos.map((video, index) => (
              <div key={index} className="video-card" data-aos="zoom-in">
                <iframe
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  frameBorder="0"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  referrerPolicy="strict-origin-when-cross-origin"
                ></iframe>
                <h4 className="video-title">{video.title}</h4>
              </div>
            ))}
          </div>

          {/*  View More Button */}
          <div className="view-more-container" data-aos="fade-up">
            <a
              href="https://www.youtube.com/@mcgansooty3246/streams"
              target="_blank"
              rel="noopener noreferrer"
              className="view-more-btn"
              referrerPolicy="strict-origin-when-cross-origin"
              aria-label="View more videos on McGAN'S YouTube channel (opens in new tab)"
            >
              View More on YouTube →
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default MediaHub;
